// Parámetros del progreso físico. `goodWhenUp` define la dirección "favorable" para colorear los
// deltas al comparar (peso/grasa/cintura/cadera: bajar = bueno; pecho/brazo/pierna: subir = músculo).
export const PARAM_DEFS = [
  { key: 'weight', label: 'Peso', unit: 'kg', goodWhenUp: false },
  { key: 'body_fat', label: '% grasa', unit: '%', goodWhenUp: false },
  { key: 'waist', label: 'Cintura', unit: 'cm', goodWhenUp: false },
  { key: 'hip', label: 'Cadera', unit: 'cm', goodWhenUp: false },
  { key: 'chest', label: 'Pecho', unit: 'cm', goodWhenUp: true },
  { key: 'arm', label: 'Brazo', unit: 'cm', goodWhenUp: true },
  { key: 'leg', label: 'Pierna', unit: 'cm', goodWhenUp: true }
];

export default PARAM_DEFS;
